<template>
<div class="chapter">
<div class="inner_page">
<div class="toc-1" id="toc-1">
<p class="centerImage1"><img alt="images" id="img6" src="images/img6.jpg" style="max-width:100%;"/></p>
<p class="caption"><em class="italic">A Map of the Parish of St Paul’s, Covent Garden from Stow’s Survey of 1755. </em><span class="fontS">Author’s collection</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06a_Fouldeeds_contents1.vue?97d1f1fa